/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterInteractionIdConfigColumn =
  (typeof FilterInteractionIdConfigColumn)[keyof typeof FilterInteractionIdConfigColumn];

export const FilterInteractionIdConfigColumn = {
  interaction_id: 'interaction_id',
} as const;
